import { SelectOption } from '@indigo-ag/component-module';
import { AgFinancingDocumentType } from '@indigo-ag/schema';
import i18next from 'core/i18n';
import orderBy from 'lodash/orderBy';

import { text as textUtils } from '../utils/text.util';

export const documentRequestTypesTranslations: Partial<Record<AgFinancingDocumentType, string>> = {
  [AgFinancingDocumentType.MATRICULA]: i18next.t('matricula'),
  [AgFinancingDocumentType.CAR]: i18next.t('CAR'),
  [AgFinancingDocumentType.LEASING_CONTRACT]: i18next.t('leasingContract'),
  [AgFinancingDocumentType.CESSION_OF_RIGHTS]: i18next.t('cessionOfRights'),
  [AgFinancingDocumentType.KML]: 'KML',
  [AgFinancingDocumentType.FIELD_MONITORING_REPORT]: i18next.t('fieldMonitoringReport'),
  [AgFinancingDocumentType.SALESFORCE_DOCUMENT]: i18next.t('salesforceDocument'),
  [AgFinancingDocumentType.OTHER]: i18next.t('other'),
  [AgFinancingDocumentType.PROMISSORY_NOTE]: i18next.t('promissoryNote'),
  [AgFinancingDocumentType.CONSENT_LETTER]: i18next.t('consentLetter'),
  [AgFinancingDocumentType.REGISTERED_LETTER_OF_CONSENT]: i18next.t('registeredLetterOfConsent'),
  [AgFinancingDocumentType.CERTIFICATE_OF_PLEDGE]: i18next.t('certificateOfPledge'),
  [AgFinancingDocumentType.OTHER_VALIDATION]: i18next.t('otherValidation'),
  [AgFinancingDocumentType.REGISTERED_CONTRACT]: i18next.t('registeredContract'),
  [AgFinancingDocumentType.AMENDMENT]: i18next.t('amendment'),
  [AgFinancingDocumentType.AMENDMENT_SIGN]: i18next.t('amendmentSign'),
  [AgFinancingDocumentType.BALANCE_DRE]: i18next.t('balanceDRE'),
  [AgFinancingDocumentType.CARD_OR_CNPJ]: i18next.t('cnpjCard'),
  [AgFinancingDocumentType.CPF]: i18next.t('cpf'),
  [AgFinancingDocumentType.CPR]: i18next.t('cpr'),
  [AgFinancingDocumentType.CPR_MINUTA]: i18next.t('cprMinuta'),
  [AgFinancingDocumentType.SIGNED_CPR]: i18next.t('signedCPR'),
  [AgFinancingDocumentType.NOTARIZED_CPR]: i18next.t('notarizedCPR'),
  [AgFinancingDocumentType.NOTARIZED_CPR_B3]: i18next.t('notarizedCPRB3'),
  [AgFinancingDocumentType.DRIVERS_LICENSE]: i18next.t('driversLicense'),
  [AgFinancingDocumentType.MARRIAGE_CERTIFICATE]: i18next.t('marriageCertificate'),
  [AgFinancingDocumentType.PROOF_OF_RESIDENCE]: i18next.t('proofOfResidence'),
  [AgFinancingDocumentType.PURCHASE_AND_SALE_CONTRACT]: i18next.t('purchaseAndSaleContract'),
  [AgFinancingDocumentType.RG]: i18next.t('RG'),
  [AgFinancingDocumentType.IRPF_RECEIPT]: i18next.t('IRPFReceipt'),
  [AgFinancingDocumentType.VISIT_HARVEST]: i18next.t('visitHarvest'),
  [AgFinancingDocumentType.VISIT_SEED_TREATMENT]: i18next.t('visitSeedTreatment'),
  [AgFinancingDocumentType.VISIT_FIRST_ASSESSMENT]: i18next.t('visitFirstAssessment'),
  [AgFinancingDocumentType.VISIT_SECOND_ASSESSMENT]: i18next.t('visitSecondAssessment'),
  [AgFinancingDocumentType.VISIT_PRE_CREDIT_REPORT]: i18next.t('visitPreCreditReport'),
  [AgFinancingDocumentType.PROMISSORY_NOTE_SIGNED]: i18next.t('promissoryNoteSigned'),
  [AgFinancingDocumentType.AF_POST_REGISTRATION_CERTIFICATE]: i18next.t('afPostRegistrationCertificate'),
  [AgFinancingDocumentType.IRPF_DECLARATION]: i18next.t('IRPDeclaration'),
  [AgFinancingDocumentType.SALES_SIMULATOR]: i18next.t('salesSimulator'),
  [AgFinancingDocumentType.SUPPLIER_ORDER]: i18next.t('supplierOrder'),
  [AgFinancingDocumentType.DETAILED_ORDER]: i18next.t('detailedOrder'),
  [AgFinancingDocumentType.HARD_MONITORING_REPORT]: i18next.t('hardMonitoringReport'),
  [AgFinancingDocumentType.FUND_ASSIGNMENT_TERM]: i18next.t('fundAssignmentTerm'),
  [AgFinancingDocumentType.BACEN_AUTHORIZATION]: i18next.t('bacenAuthorization'),
  [AgFinancingDocumentType.SALES_REPORT]: i18next.t('salesReport'),
  [AgFinancingDocumentType.STATE_REGISTRATION]: i18next.t('stateRegistration'),
  [AgFinancingDocumentType.MATRICULA_PATRIMONY]: i18next.t('matriculaPatrimony'),
  [AgFinancingDocumentType.CREDIT_SHEET]: i18next.t('creditSheet'),
  [AgFinancingDocumentType.SALESFORCE_CHATTER_ATTACHMENT]: i18next.t('chatterAttachment'),
  [AgFinancingDocumentType.CREDIT_OPINION]: i18next.t('creditOpinion'),
  [AgFinancingDocumentType.SERASA]: i18next.t('serasa'),
  [AgFinancingDocumentType.BIRTH_CERTIFICATE]: i18next.t('birthCertificate'),
  [AgFinancingDocumentType.DIVORCE_CERTIFICATE]: i18next.t('divorceCertificate'),
  [AgFinancingDocumentType.LAND_PURCHASE_AND_SALE_AGREEMENT]: i18next.t('landPurchaseAndSaleAgreement'),
  [AgFinancingDocumentType.DRE]: i18next.t('dre'),
  [AgFinancingDocumentType.DEBT_RENEGOTIATION_TERM_PROCESSES_IN_AGREEMENT]: i18next.t(
    'debtRenegotiationTermProcessesInAgreement'
  ),
  [AgFinancingDocumentType.DEBT_ACKNOWLEDGMENT]: i18next.t('debtAcknowledgment'),
  [AgFinancingDocumentType.DUPLICATE_INVOICE]: i18next.t('duplicateInvoice'),
  [AgFinancingDocumentType.SIGNED_DEBT_ACKNOWLEDGMENT]: i18next.t('signedDebtAcknowledgment'),
  [AgFinancingDocumentType.SIGNED_DUPLICATE_INVOICE]: i18next.t('signedDuplicateInvoice')
};

const getDocumentTypeTranslation = (docType: string) => {
  return documentRequestTypesTranslations[docType as AgFinancingDocumentType];
};

const documentRequestTypes: SelectOption<AgFinancingDocumentType>[] = Object.keys(AgFinancingDocumentType)
  .filter(
    docType => docType !== AgFinancingDocumentType.SALESFORCE_DOCUMENT && !!getDocumentTypeTranslation(docType) // To avoid null values in the select option
  )
  .map(docType => ({
    name: getDocumentTypeTranslation(docType) ?? '',
    value: docType as AgFinancingDocumentType
  }));
const amendmentRequestTypes: SelectOption<AgFinancingDocumentType>[] = Object.keys(AgFinancingDocumentType)
  .filter(docType =>
    [
      AgFinancingDocumentType.AMENDMENT,
      AgFinancingDocumentType.CONSENT_LETTER,
      AgFinancingDocumentType.CERTIFICATE_OF_PLEDGE,
      AgFinancingDocumentType.OTHER
    ].includes(docType as AgFinancingDocumentType)
  )
  .map(docType => ({
    name: textUtils.toTitleCase(getDocumentTypeTranslation(docType) ?? ''),
    value: docType as AgFinancingDocumentType
  }));

export const documentRequestTypesOptions: SelectOption<AgFinancingDocumentType>[] = orderBy(
  [...documentRequestTypes.filter(option => option.value !== AgFinancingDocumentType.CPR_MINUTA)],
  ['name']
);
export const amendmentRequestTypesOptions: SelectOption<AgFinancingDocumentType>[] = orderBy(amendmentRequestTypes, [
  'name'
]);

export enum DocumentRequestErrorsOnDelete {
  WITHOUT_PERMISSIONS = 'Not enough permissions to delete this request',
  WITH_FILES = 'Request with files can not be deleted'
}
